<template>
    <div class="modal-card">
        <header class="modal-card-head has-background-white">
            <h3 class="modal-card-title has-text-centered">
                Asignar el libro general(Clasificacion)
            </h3>
            <button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
        </header>
        <section class="modal-card-body">
            <div class="columns">
                <div class="column is-8">
                    <InputWithValidation id="idSheet" name="idSheet" label="Spreadsheet ID:" v-model="idSheet"
                        rules="required" />
                </div>
            </div>
        </section>
        <footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
            <button class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
                Volver
            </button>
            <button class="button is-primary" aria-label="Modificar Recurrencia" :disabled="loading || idSheet == ''"
                role="button" @click="saveNewIdSheet()">
                Grabar
            </button>
        </footer>
    </div>
</template>

<script>
import { updateGeneralBookSheetId } from "@/api/carteraAnalista";
import InputWithValidation from "@/components/inputs/InputWithValidation";
import { consoleHandlerError, notificate } from "@/utils/message";

export default {
    name: "IdSheetUpdate",
    data() {
        return {
            loading: false,
            idSheet: "",
        };
    },
    components: {
        InputWithValidation
    },
    methods: {
        saveNewIdSheet() {
            this.loading = true
            updateGeneralBookSheetId(this.idSheet, this.companyId).then(() => {
                notificate(
                    `<strong>Éxito!</strong><br>
                    Se actualizó el id del libro general`,
                    "is-success is-light"
                );
                this.$emit("updateIdSheet", this.idSheet);
                this.$emit("close");
            }).catch(error => {
                consoleHandlerError({ error, empty: true });
                this.$emit("close");
            }).finally(() => {
                this.loading = false
            })
        },
    },
    props: ["companyId", "general_book_id_sheet"],
    created() {
        if (this.general_book_id_sheet) {
            this.idSheet = this.general_book_id_sheet
        }
    },
};
</script>
